import { initialState } from "../initialState";
import * as Alert from "./alertActions";

export const alertReducer = (state = initialState.alerts, action) => {
    switch (action.type) {
        // Append new alert to the alert array
        case Alert.SHOW_ALERT:
            return [...state, action.alert];

        // Remove the alert from the array of pending alerts
        case Alert.ALERT_SHOWN:
            return state.filter((n) => n.key !== action.key);

        default:
            return state;
    }
};
